export default "<!-- Component's placeholder -->\n\n<router-outlet></router-outlet>"